/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ProdIssFServ01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const prodIssFServ01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prodIssFServ01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const prodIssFServ01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const prodIssFServ01ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const prodIssFServ01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const prodIssFServ01FetchProdIssFServ01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prodIssFServ01FetchProdIssFServ01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const prodIssFServ01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const prodIssFServ01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const prodIssFServ01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const prodIssFServ01ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_SHOW_SYNC_SETTING_LOADING]: prodIssFServ01ShowSyncSettingLoading,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_SHOW_SYNC_SETTING_SUCCESS]: prodIssFServ01ShowSyncSettingSuccess,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_SHOW_BATCH_JOB_STATUS_SUCCESS]: prodIssFServ01ShowBatchJobStatusSuccess,

  [ProdIssFServ01Types.PROD_ISS_F_SERV01_RESET_TIMESTAMP]: prodIssFServ01ResetTimestamp,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_FETCH_PROD_ISS_F_SERV01_LOADING]: prodIssFServ01FetchProdIssFServ01Loading,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_FETCH_PROD_ISS_F_SERV01_SUCCESS]: prodIssFServ01FetchProdIssFServ01Success,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_ADD_SELECTED_DOCUMENTS]: prodIssFServ01AddSelectedDocuments,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_REMOVE_SELECTED_DOCUMENTS]: prodIssFServ01RemoveSelectedDocuments,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_SET_WORKSPACE_VISIBLE]: prodIssFServ01SetWorkspaceVisible,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_EXPORT_LOADING]: prodIssFServ01ExportLoading,
  [ProdIssFServ01Types.PROD_ISS_F_SERV01_EXPORT_SUCCESS]: prodIssFServ01ExportSuccess
});
